import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase"; // adjust the path as needed

export const fetchAvailableEvents = async () => {
  try {
    const eventsRef = collection(db, "events");
    const eventsQuery = query(eventsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(eventsQuery);

    // Map documents to event objects
    const events = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    // For each event, fetch its content, pick a random document, and attach submissionSaleId and all content
    const eventsWithContent = await Promise.all(
      events.map(async (event) => {
        const contentRef = collection(db, "events", event.id, "content");
        const contentSnapshot = await getDocs(contentRef);

        if (!contentSnapshot.empty) {
          // Convert content documents to an array of data
          const contentDocs = contentSnapshot.docs;
          const contentData = contentDocs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // Pick a random document for randomSaleId
          const randomIndex = Math.floor(Math.random() * contentDocs.length);
          const randomDoc = contentDocs[randomIndex];

          return {
            ...event,
            randomSaleId: randomDoc.data().submissionSaleId,
            content: contentData, // attach all content data
          };
        }
        // Exclude events with no content
        return null;
      })
    );

    // Filter out events without content
    return eventsWithContent.filter((event) => event !== null);
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};
